var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-block',{attrs:{"value":_vm.value,"mode":_vm.mode},scopedSlots:_vm._u([{key:"main",fn:function(){return [_c('shape-style',{attrs:{"shape":_vm.value.data.shape,"width":_vm.value.size.width,"height":_vm.value.size.height,"shape-style":_vm.value.data.style}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }